import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { UserSelfApiResponse } from "../../types/user/UserSelfDTO";
import { branchApiUserAuthQuery } from "../utils/Extensions";
import { useUserSelfStore } from "../userSelfStore";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: branchApiUserAuthQuery,
  tagTypes: ["user-self"],
  endpoints: (builder) => ({
    getUsersSelf: builder.query<UserSelfApiResponse, void>({
      query: () => ({
        method: "GET",
        url: "/v1/users/self",
      }),
      providesTags: ["user-self"],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          useUserSelfStore.getState().setUserSelf(data.data ?? null);
        } catch {
          useUserSelfStore.getState().reset();
        }
      },
    }),
  }),
});

export const { useGetUsersSelfQuery } = userApi;
